import { AxiosError } from "axios";
import http from "./http.service"
export const REQUEST_PASSWORD_URL = `/auth/admin/forgot_password`;
export const RESET_PASSWORD_URL = `/auth/admin/reset_password`;
export const ACCOUNT_VERIFICATION_URL = `/auth/member/verifyAccount`;
export const EMAIL_EXIST_URL = `/auth/member/exists`;
export const CHECK_MEMBER_URL = `/auth/member/checkMember`;
export const FORGOT_PASSWORD_URL = `/auth/partner/forgotPassword`;
export const CHANGE_PASSWORD_URL = `/auth/partner/changePassword`;

export const loginUser = async (payload: any) => {
  return http.post('/auth/login', payload);
}

export const verifyOTP = async (payload: any) => {
  return http.post('/auth/verify-otp', payload);
}

export const resendOTP = async (payload: any) => {
  return http.post('/auth/resend-otp', payload);
}

export const registerUser = async (payload: any) => {
  return http.post('/auth/register', payload);
}

export const forgotPassword = async (payload: any) => {
  return http.post('/auth/forget-password', payload);
}

export const resetPassword = async (token: any, payload: any) => {
  return http.post(`/auth/reset-password/${token}`, payload);
}

export const logOut = async () => {
  return http.post(`/auth/logout`, {});
}

export function requestVerifyAccount(token: string) {
  return http.post<{ result: any }>(ACCOUNT_VERIFICATION_URL, {
    token
  })
}

export const createNewPassword = async (payload: any) => {
  return http.put('/auth/partner/createNewPassword', payload);
}

export const verifyPasswordLink = async (id: any, otp: any) => {
  return http.get(`/auth/partner/resetLink/${id}?otp=${otp}`);
}
